export const successActionFrom = (action, result) => ({
  ...action, result,
  type: action.type + '_SUCCESS'
});

export const errorActionFrom = (action, error) => ({
  ...action, error,
  errorMessage: error ? error.toString() : "",
  type: action.type + '_ERROR'
});

export const actionCausedByURLChangeFrom = action => ({
  ...action,
  causedByURLChange: true
});

export const textEditingUpdateTextMaker = type => ({ text, emojiShortName, selectionStart, ...other }) => {
  if(emojiShortName) {
    return {
      type,
      text: text.substring(0, selectionStart) + emojiShortName + text.substring(selectionStart, text.length),
      ...other
    };
  }

  return { type, text, ...other };
};



/** WEBPACK FOOTER **
 ** ./src/members/state/__shared__/utils/actions.js
 **/